<template>
  <div>
    <label
        class="checkbox-wrapper"
        :class="classMode"
    >
      <input
          :id="labelId"
          type="checkbox"
          class="check"
          :checked="chosen"
          :disabled="disabled"
          @change="onChange"
      >
      <label
          :for="labelId"
          class="toggle"
      >
        <span class="circle" />
      </label>
      <span
          v-if="Object.keys(styled).length > 0 && chosen"
          class="text"
          v-html="getStyledTitle"
      />
      <span
          v-else
          class="text"
      >
        {{ title }}
      </span>
    </label>
  </div>
</template>

<script>
    import { DecorateHelper } from 'reusable-helpers';

    export default {
        name: "ToggleSwitch",
        data() {
            return {
              uniqId: '',
            }
        },
        props: {
            id: {
                type: String,
                default: '',
                required: false
            },
            title: String,
            mode: {
                type: Array,
                default () { return [] },
                required: false,
            },
            styled: {
                type: Object,
                required: false,
                default () {
                    return {}
                }
            },
            chosen: Boolean,
            disabled: {
                type: Boolean,
                required:  false,
            },
        },

        computed: {
            classMode() {
                return {
                    'toggle-switch_eb': (this.mode.indexOf('exportbase') !== -1),
                    'toggle-switch_chosen': this.chosen,
                    'checkbox-wrapper_checked': this.chosen,
                }
            },
            getStyledTitle () {
                let highLightControlTitle = '';
                switch (this.styled.styleType) {
                    case 'highlight':{
                        highLightControlTitle = DecorateHelper.highLightControlTitle(
                            this.title,
                            this.title,
                            this.styled.backgroundColor,
                            this.styled.textColor
                        );
                        break;
                    }
                    default: break;
                }

                return highLightControlTitle;
            },
            labelId() {
                return `${this.id}_${this.uniqId}`;
            }
        },

        created() {
          this.uniqId = this.generateUniqueId();
        },

        methods: {
            onChange(e) {
                this.$emit(
                    'set-chosen-item',
                    e.target.id.substr(0, e.target.id.length - this.uniqId.length - 1)
                );
            },

            generateUniqueId() {
              const str = `${this.title}${JSON.stringify(this.mode)}`;
              let hash = 0;
              for (let i = 0; i < str.length; i++) {
                hash = ((hash << 5) - hash) + str.charCodeAt(i);
                hash = hash & hash;
              }
              return Math.abs(hash).toString(36);
            }
        },
    }
</script>

<style scoped>
    .text {
        display: inline-block;
        word-break: break-word;
    }

    .toggle-switch_eb .text {
        padding: 3px 5px;
    }

    .toggle-switch_eb.toggle-switch_chosen .text {
        color: #353535;
        font-weight: 700;
    }

    .checkbox-wrapper{
      display: flex;
      gap: 10px;
      align-items: center;
    }

    .checkbox-wrapper input[type="checkbox"] {
      visibility: hidden;
      display: none;
    }

    .checkbox-wrapper .toggle {
      position: relative;
      display: block;
      width: 40px;
      height: 20px;
      cursor: pointer;
      -webkit-tap-highlight-color: transparent;
      transform: translate3d(0, 0, 0);
      border-radius: 10px;
    }

    .checkbox-wrapper .toggle:before {
      content: "";
      position: relative;
      top: 50%;
      transform: translate(0, -50%);
      left: 3px;
      width: 28px;
      height: 15px;
      display: block;
      background: #b3b3b3;
      border-radius: 8px;
      transition: background 0.2s ease;
      border: 1px solid #DDD;
    }

    .checkbox-wrapper .toggle .circle {
      position: absolute;
      top: 50%;
      transform: translate(0, -50%);
      left: 0;
      width: 15px;
      height: 15px;
      display: block;
      background: #EEE;
      border-radius: 50%;
      box-shadow: 0 3px 8px rgba(154, 153, 153, 0.5);
      transition: all 0.2s ease;
      border: 1px solid #DDD;
    }

    .checkbox-wrapper_checked .check + .toggle .circle {
      transform: translate(20px, -50%);
      box-shadow: 0 3px 8px rgb(79 46 220 / 20%);
    }

    .checkbox-wrapper_checked .check + .toggle:before{
      background: #91AD2C;
    }

    .checkbox-wrapper_checked #cbx + .toggle .circle:before {
      transform: scale(1);
      opacity: 0;
      transition: all 0.4s ease;
    }
</style>
